import React, { memo } from "react";
import MaskService from "../../utils/mask/maskService";

// Import do TextField do material feito no styled components
import { TextFieldCustom } from "./styles/TextFieldErp";
import CircularProgress from "@material-ui/core/CircularProgress";

const TextFieldErp = ({
  textAlignCenter = false,
  textAlignRight = false,
  startAdornment = null,
  endAdornment = null,
  InputProps = {},
  variant = "standard",
  maxLength,
  disabled = false,
  mask = null,
  decimals = 2,
  value,
  setValue,
  size = "small",
  hightlighted = false,
  onBlur = (e) => {},
  onChange = (e) => {
    if (maxLength) {
      e.target.value = e.target.value.substring(0, maxLength);
    }

    mask
      ? setValue(MaskService.toMask(mask, e.target.value, decimals))
      : setValue(e.target.value);
  },
  className = "filter-input",
  error = false,
  helperText,
  loading,
  ...props
}) => {
  return (
    <TextFieldCustom
      {...props}
      style={{ width: "100%" }}
      value={
        mask ? MaskService.toMask(mask, value || "", decimals) : value || ""
      }
      variant={variant}
      disabled={disabled}
      size={size}
      helperText={helperText || ""}
      error={!!error}
      onChange={(e) => {
        onChange(e);
      }}
      onBlur={(e) => {
        onBlur(e);
      }}
      inputProps={InputProps}
      $textAlignRight={textAlignRight}
      $textAlignCenter={textAlignCenter}
      className={className}
      InputProps={{
        endAdornment: (
          <>
            {loading ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              endAdornment ?? null
            )}
          </>
        ),
        startAdornment: <>{startAdornment ?? null}</>,
      }}
      maxLength={maxLength}
    />
  );
};

export default memo(TextFieldErp);
